module.exports = __webpack_public_path__ + "assets/img/7cf117aba4e801f70c8ad2835dd1f58d.png";